import { Box, Button, Card, CardContent, CardMedia, Container, IconButton, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'



import { getallcombooffer, addtoCart  } from '../services/Apis'; // Update this import
import useResponsive from '../hooks/useResponsive';
import { useNavigate } from 'react-router-dom';
import { useFilter } from '../context/FilterContext';

const AllCombos = () => {
    const [comboData, setComboData] = useState([]);
    const navigate = useNavigate()

  const { token, isLoggedIn } = useFilter ()
      const handleAddToCart = async (bookId) => {
  
          if (isLoggedIn && token) {
              try {
                  await addtoCart({ bookId, quantity: 1 });
                  navigate('/cart');
              } catch (error) {
                  alert("Failed to add to cart. Please login or try again.");
              }
          } else {
              navigate("/login")
          }
      };

     
    useEffect(() => {
        const fetchBooks = async () => {
            const books = await getallcombooffer();
            setComboData(books.comboOffers || []);
        };
        fetchBooks();
    }, []);
   
     const handleBuyNow = async (book) => {
         if (isLoggedIn && token) {
        try {
            navigate('/checkout', { state: book });

        } catch (error) {
            console.log("Failed to add to cart. Please login or try again.");
        }} else {
            navigate("/login")
        }
    };
    const { isSmallScreen } = useResponsive()

    return (
        <Container maxWidth='xl' width={'100%'} sx={{  pl: '10px !important' }} >
            <Box display="flex" justifyContent="space-between" alignItems="center" mt={3} mb={1.5} >
                <Typography
                    variant="h3"
                    sx={{
                        fontWeight: 600,
                        fontFamily: 'Poppins',
                        color: '#CB4422',
                       mt:{xs:2 , md:0},
                        paddingLeft: 1,
                    }}
                >
                    Combo Offer Books
                </Typography>

               
            </Box>
            <Box
                sx={{
                   display: "flex",
                   flexWrap:'wrap',
                   gap:1,
                    justifyContent:{xs:'center' , md:"start"},
                    
                    mb:2

                    // Hide scrollbar
                    
                }}
            >
                {comboData.map((book) => (
                 
                    <Box key={book.id}
                       
                        sx={{ minWidth: { xs: '100%', sm: 280, md: 250, lg:250} , flexShrink: 0, cursor: "pointer" , display:'flex' , justifyContent:{xs:'center' , md:'start'} }}
                    // onClick={() => singleProduct(book.id)}
                    >
                         
                        <Card sx={{ position: 'relative', boxShadow: 'none', border: '1px solid lightgrey', width: isSmallScreen ? 250 : 220 }}>
                            {/* Discount badge */}
                            <Box sx={{
                                position: 'absolute', top: 8, left: 0, bgcolor: 'black',
                                color: 'white', px: 1, py: 0.5, fontSize: '12px', zIndex: 2, borderRadius: 0.5,
                            }}
                            >
                                {book.discountOffer}% off
                            </Box>

                            {/* Shopping Cart icon */}
                            <IconButton disableFocusRipple disableRipple
                                sx={{
                                    position: 'absolute', top: 8, right: 8, zIndex: 2, bgcolor: '#FFB300', color: '#000', '&:hover': {
                                        bgcolor: '#FFB300',
                                    },
                                }}
                                onClick={() => handleAddToCart(book.id)}
                            >
                                <i class="fa-solid fa-cart-shopping" style={{ fontSize: '14px', color: 'black' }}></i>
                            </IconButton>

                            {/* Book Image */}
                            <CardMedia
                                component="img" loading='lazy' height="200" width={200}
                                onClick={() => navigate(`/combo-overview/${book.id}`)}
                                image={book.imageUrl}
                                alt={book.title}
                                sx={{ objectFit: 'cover' }}
                            />

                            <CardContent sx={{ textAlign: 'center' }}>
                                {/* Title */}
                                <Typography variant="body1" fontWeight="bold" noWrap sx={{ my: 0 }}>
                                    {book.title}
                                </Typography>

                                {/* Yearly & Author */}
                                <Typography fontSize={10} variant="caption" color="text.secondary" >
                                    Yearly - {book.yearly}, by {book.author}
                                </Typography>

                                {/* Rating */}
                                {/* <Box mt={1}>  <Rating value={book.rating} precision={0.5} readOnly size="small" />   </Box> */}

                                {/* Price and Buy Now */}
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 1 }}  >
                                    <Typography variant="body2" color="#000">
                                        ₹{book.price.toFixed(2)}
                                    </Typography>

                                    <Button variant="contained" size="small" onClick={() => handleBuyNow(book)}
                                        sx={{
                                            textTransform: "none", fontSize: "10px", borderRadius: "2px", px: 2, boxShadow: "none",
                                            "&:hover": { backgroundColor: "primary.main", boxShadow: "none", },
                                        }}
                                    >   Buy Now
                                    </Button>
                                </Box>
                            </CardContent>
                        </Card>
                    </Box>
                ))}
            </Box>
        </Container>

    )
}

export default AllCombos